<template>
  <AnalyticsCards />
</template>
<script setup>
import AnalyticsCards from '@/components/hijo1/AnalyticsCards.vue';
</script> 